import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { NIL } from 'uuid';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// dart (2026-07-14) — #25: a subscription's commission earners (for the edit-going-forward modal).
export interface RecurringEarner {
  userId: string;
  recurringRevenueItemId?: string | null; // null = % of the whole subscription
  percent: number;
}

export const useRecurringEarners = (id?: string) => useQuery(
  ['recurringEarners', id],
  async (): Promise<RecurringEarner[]> => {
    const { data } = await axios.get(`${apiUrl()}RecurringRevenue/${id}/earners`);
    return (data ?? []) as RecurringEarner[];
  },
  { enabled: !!id && id !== NIL, refetchOnWindowFocus: false },
);

// REPLACE the subscription's earners (already-accrued months stay; the new set applies going forward)
export const useRecurringEarnersSave = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (vars: { id: string; earners: RecurringEarner[] }) => axios.post(
      `${apiUrl()}RecurringRevenue/${vars.id}/earners`, vars.earners,
    ),
    {
      onSettled: async (_r, _e, vars) => {
        await queryClient.invalidateQueries(['recurringEarners', vars.id]);
        await queryClient.invalidateQueries('recurringRevenue');
      },
    },
  );
};
